import { render, staticRenderFns } from "./ContactsTab.vue?vue&type=template&id=0606a366&scoped=true"
import script from "./ContactsTab.vue?vue&type=script&lang=js"
export * from "./ContactsTab.vue?vue&type=script&lang=js"
import style0 from "./ContactsTab.vue?vue&type=style&index=0&id=0606a366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0606a366",
  null
  
)

export default component.exports